import { render, staticRenderFns } from "./activitytemplate1.vue?vue&type=template&id=cfd0705a&scoped=true"
import script from "./activitytemplate1.vue?vue&type=script&lang=js"
export * from "./activitytemplate1.vue?vue&type=script&lang=js"
import style0 from "./activitytemplate1.vue?vue&type=style&index=0&id=cfd0705a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd0705a",
  null
  
)

export default component.exports